<template lang="pug">
app-page(:fabItems="fabItems" title="Реестр судей" :loading="loading" @search="text => (search = text.toLowerCase())")
  app-toolbar(:title="'Реестр Судей'")
    app-toolbar-item.ml-2(label="Суд" all="все" :items="courts" key-name="name" min-width="120" @select="selectCourt") 
      | {{ selectedCourt ? selectedCourt.name : 'все' }}
    app-toolbar-item.ml-2(label="Тип рассматриваемых дел" all="все" :items="caseTypes" key-name="title" min-width="120" @select="selectType") 
      | {{ selectedType ? selectedType.title : 'все' }}
    app-toolbar-item.ml-2(label="Показать" all="все" :items="archiveTypes" key-name="title" min-width="120" @select="selectArchive") 
      | {{ selectedArchive ? selectedArchive.title : 'все' }}
  
  .text-right
    v-chip.ma-2(v-if="search" color="#757575" text-color="white" small label close @click:close="search = null") Поиск:&nbsp;<b>{{ search }}</b>
    v-chip.ma-2(v-if="selectedType" color="#757575" text-color="white" small label close @click:close="selectType(null)") Тип дел:&nbsp;<b>{{ selectedType.title  }}</b>
    v-chip.ma-2(v-if="selectedArchive" color="#757575" text-color="white" small label close @click:close="selectArchive(null)") Показать:&nbsp;<b>{{ selectedArchive.title  }}</b>
    v-chip.ma-2(v-if="selectedCourt" color="#757575" text-color="white" small label close @click:close="selectCourt(null)") Показать:&nbsp;<b>{{ selectedCourt.name  }}</b>

  app-empty-list(v-if="listJudges.length == 0") Список пуст
  app-group-animation
    app-group-item(v-for="j in listJudges" :key="j.id" cols="4")
      app-card(@click.native="showJudgeDetail(j)")
        app-card-header
          v-layout 
            v-flex.pt-1(xs1)
              app-indicator(:color="getHoliday(j).color" size="10")
            v-flex.text-left
              span(v-if="j.caseTypes.length == 0") Тип дел не выбран
              span {{ j.caseTypes.map(item => item.title).join(",") }}
            v-flex.text-right
              v-tooltip(bottom)
                template(v-slot:activator="{ on }")
                  v-icon(v-if="j.butterflynet || j.archive"  size="24" color="red" style="margin-top:-6px;" v-on="on") blur_off
                  v-icon(v-else size="24" color="green" style="margin-top:-6px;" v-on="on") blur_on
                span {{ j.butterflynet ? 'Не участвует в распределение' : 'Участвует в распределение' }}
  
        app-card-body
          app-card-caption {{ j.court.name }}
          app-card-title(v-html="judgeLastName(j)")
          app-card-caption Последняя синхронизация - {{ j.lastSync ? $_formatRu(j.lastSync) : 'не проводилась' }}
          app-card-caption до начала периода 
            b {{ j.fullcount }}
          app-card-caption 
            v-layout
              v-flex с учетом распределения 
                b {{ j.count }}
              v-flex.text-right(v-bind:class="{ 'red--text': j.archive || getHoliday(j).color==='red' }") {{ getHoliday(j).text }}

  app-dialog(v-model="dialog.addJudge" :header="'Добавить судью'" width="400")
    v-layout.mt-1
      v-flex(xs12)
        v-form(ref="formJudge")
          app-card-title ФИО судьи
          app-text-field(v-model="judgeForm.firstName" label="Имя" :rules="[rules.required]") 
          app-text-field(v-model="judgeForm.middleName" label="Отчество" :rules="[rules.required]")
          app-text-field(v-model="judgeForm.lastName" label="Фамилия" :rules="[rules.required, rules.text]")
          app-card-caption.ml-1 Номер конференц зала должен начинаться: "a-..."(лат.)
          app-text-field(v-model="judgeForm.hall" label="Конференц зал" :rules="[rules.required]")
          app-select(v-model="judgeForm.court" :items="courts" label="Наименование суда" :rules="[rules.required]" item-text="name" return-object)
          app-select(v-model="judgeForm.caseTypes" :items="caseTypes" label="Тип рассматриваемых дел" :rules="[rules.required]" item-text="title" multiple return-object)
          app-button-action(@click="addJudge()") добавить
          
              
  app-dialog-loading(v-model="syncLoading")
 
</template>

<script>
import { syncService, judgeService } from "@/_services";
import { mapGetters, mapMutations, mapState } from 'vuex'
import { AppDialogLoading } from '@/components'
import { $_app_moment } from "@/common/AppMoment.js"
import Meeting from '@/common/Meeting'
import { $_validate_rules } from '@/common/ValidateRules'

import moment from 'moment'
moment.locale('ru')

export default {
  mixins: [ $_app_moment, Meeting, $_validate_rules ],

  components: {
    [AppDialogLoading.name]: AppDialogLoading,
  },
  data () {
    const defaultForm = Object.freeze({
        firstName:	null,
        lastName:	null,
        middleName:	null,
        caseTypes: null,
        court: null,
        archive: false,
        hall: null,
        butterflynet: true
    })

    return {
      syncLoading: false,
      search: null,
      archiveTypes: [
        {title: "активные", value: false},
        {title: "архивные", value: true},
      ],
      dialog: {
        addJudge: false
      },
      judgeForm: Object.assign({}, defaultForm),
      defaultForm,
    }
  },

  mounted () {
    this.$store.commit('setInJudgeReestr', true)
    this.$store.dispatch('judgeReestr/INIT_JUDGES')
    this.$store.dispatch('court/INIT')
  },

  computed: {
    ...mapState("judgeReestr", ["selectedType", 'selectedArchive', 'selectedCourt']),
    ...mapGetters('judgeReestr', ['judges', 'isJudgesLoaded', 'caseTypes']),
    ...mapState('court', ['courts']),
    

    loading () {
      return !this.isJudgesLoaded
    },

    fabItems () {
      let items = [{ icon:'sync', title:'Синхронизация судей', action: () =>  this.syncJudges()}]
      if (this.$_meeting_isAvailable || (window.settings.limitMenu && window.settings.limitMenu.available==true && window.settings.limitMenu.key== 'gsu') ) 
        items.push({ icon:'add', title:'Добавить судью', action: () =>  this.showAddJudge()})
      return items
    },

    listJudges () {
      let list = this.judges
      if (this.selectedType)
        list = list.filter(j => j.caseTypes.find(type => type.value == this.selectedType.value))
      if (this.selectedArchive)
        list = list.filter(j => j.archive == this.selectedArchive.value)
      if (this.selectedCourt) 
        list = list.filter(j => j.court.name === this.selectedCourt.name)
      else if (this.courts.length == 1) 
        list = list.filter(j => j.court.name === this.courts[0].name)
      if (this.search) 
        list = list.filter(item => (item.lastName + ' ' + this.isNull(item.firstName) + this.isNull(item.middleName)).toLowerCase().includes(this.search))
      return list
    }

  },

  methods: {
    ...mapMutations("judgeReestr", ["selectType", 'selectArchive', 'addJudgeInJudges', 'selectCourt']),

    showAddJudge () {
      this.judgeForm = JSON.parse(JSON.stringify(this.defaultForm))
      return this.dialog.addJudge = true
    },

    judgeLastName (judge) {
      let fio = judge.lastName + ' ' + this.isNull(judge.firstName) + this.isNull(judge.middleName)
      if (!this.search || this.search.length == 0 ) {
        return fio
      }
      return fio.replace(new RegExp(this.search, "gi"), match => {
        return `<span style="color: #00BCD4; margin: 0px 1px;">${match}</span>`
      })
    },

    syncJudges () {
      this.syncLoading = true
      syncService.syncJudges().then(() => {
        this.syncLoading = false
        this.$store.dispatch('judgeReestr/INIT_JUDGES')
      })
      .catch(() => {
        this.syncLoading = false
      })
    },

    addJudge () {
      if (this.$refs.formJudge.validate()) {
        judgeService.addJudge(this.judgeForm).then(data=> {
          this.addJudgeInJudges(data)
          this.$store.dispatch('judgeReestr/INIT_JUDGES')
          this.dialog.addJudge = false
        })
      }
    },

    getHoliday (curJudge) {
      let statusDate = ''
      if (curJudge.archive) return {"color": "grey", "text": 'архивный'}
      if (curJudge.holiday && statusDate === '') {
        curJudge.holiday.map( item => {
            if (moment().isBefore(moment(item.startDate))) 
              statusDate = {"color": "yellow", "text": "на работе до " + moment(item.startDate).format("DD.MM.YYYY")}
            else if ( moment().isSameOrAfter( moment(item.startDate) ) && moment().isSameOrBefore(moment(item.endDate)) )
              statusDate = {"color": "red", "text": item.holidayType.title + " до " + moment(item.endDate).format("DD.MM.YYYY")}
        })
      }
      return statusDate!='' ? statusDate : {"color": "green", "text": 'на работе до 31.12.' + moment().year()}
    },

    isNull (text) {
      return text ? text.slice(0,1) + '.' : ''
    },

    showJudgeDetail(selectedJudge) {
      this.$router.push({ path: `/admin/judges/${selectedJudge.id}` })
    },
  },
  beforeDestroy() {
    this.$store.commit('setInJudgeReestr', false)
  }
}
</script>